
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SystemMessage } from '@/models/SystemMessage'
import SystemMessageType from '@/enums/SystemMessageType'
import moment from 'moment'

@Component({})
export default class SystemNotificationBar extends Vue {
	@Prop({ default: () => [] })
	systemMessages!: Array<SystemMessage>

	dismissedIds: Array<string> = []

	created() {
		this.loadDismissedIds()
	}

	loadDismissedIds() {
		const keys = Object.keys(localStorage).filter((k) => k.startsWith('dismissed-system-message-'))
		this.dismissedIds = keys.map((k) => k.replace('dismissed-system-message-', ''))
	}

	get activeMessages(): Array<SystemMessage> {
		const now = moment()
		const ms = this.systemMessages.filter((msg) => {
			if (!msg.showDate) return false
			return moment(msg.showDate).isSameOrBefore(now)
		})

		return ms
	}

	isActive(msg: SystemMessage): boolean {
		if (!msg.startAt) return false
		const now = moment()
		if (!moment(msg.startAt).isSameOrBefore(now)) return false
		if (!msg.endAt) return true
		return now.isSameOrBefore(moment(msg.endAt))
	}

	isDismissable(msg: SystemMessage): boolean {
		return !this.isActive(msg)
	}

	get visibleMessages(): Array<SystemMessage> {
		return this.activeMessages.filter((msg) => {
			if (this.isActive(msg)) return true
			return !this.dismissedIds.includes(String(msg.getApiId()))
		})
	}

	dismiss(msg: SystemMessage) {
		localStorage.setItem(`dismissed-system-message-${msg.getApiId()}`, 'true')
		this.dismissedIds = [...this.dismissedIds, String(msg.getApiId())]
	}

	alertColor(msg): string {
		return msg.messageType === SystemMessageType.INFO ? '#74d4ff' : '#ffba00'
	}
}
